import { View } from "binder"
import { CreditPaymentViewModel } from "./creditPayment-viewModel";

export class CreditPaymentView extends View<CreditPaymentViewModel>{
    GetViewUniqueId(): string {
        return "V-0E8425E1-73BD-4631-88E0-CBF4BBFADB98"
    }
    loadHtml(): string {
        let element = require('./creditPayment.html').default;
        let style = require('./creditPayment.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set maxAmount(v: number) { this._maxAmount = v; } public get maxAmount(): number { return this._maxAmount;} private _maxAmount: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid;} private _isAmountInvalid: boolean;
    public set customerCredit(v: number) { this._customerCredit = v; } public get customerCredit(): number { return this._customerCredit;} private _customerCredit: number;
    public set customerCreditDaysCount(v: number) { this._customerCreditDaysCount = v; } public get customerCreditDaysCount(): number { return this._customerCreditDaysCount;} private _customerCreditDaysCount: number;
    public set customerAccountBalance(v: number) { this._customerAccountBalance = v; } public get customerAccountBalance(): number { return this._customerAccountBalance;} private _customerAccountBalance: number;
    public set customerCreditType(v: string) { this._customerCreditType = v; } public get customerCreditType(): string { return this._customerCreditType;} private _customerCreditType: string;
    public set isAccountBalanceDebit(v: boolean) { this._isAccountBalanceDebit = v; } public get isAccountBalanceDebit(): boolean { return this._isAccountBalanceDebit;} private _isAccountBalanceDebit: boolean;
    public set accountBalanceLabel(v: string) { this._accountBalanceLabel = v; } public get accountBalanceLabel(): string { return this._accountBalanceLabel;} private _accountBalanceLabel: string;
    
}
